/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Standings_CutoffInputs */



/**
* | output |
* | --- |
* | "Cutoff" |
*
* @param {Tournament_Standings_CutoffInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_standings_cutoff = /** @type {((inputs?: Tournament_Standings_CutoffInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Standings_CutoffInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corte")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Corte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Soglia")
	return /** @type {LocalizedString} */ ("Cutoff")
});